import { queryGetReport } from '../Queries';

import moment from 'moment-timezone';
import featureFlags from '../featureFlags';

const isEmpty = value => value === null || value === '' || value === undefined;

const convertToGraphQLFilters = (facilityId, filterValues) => {

  const filters = [{
    model: 'BILLING_PROFILE',
    field: 'facility_id',
    op: 'EQ',
    value: `${facilityId}`
  }];

  if (!isEmpty(filterValues.payorId)) {
    filters.push({
      model: 'PAYOR',
      field: 'readable_id',
      op: 'SUBSTRING',
      value: `${filterValues.payorId}`
    });
  }

  if (featureFlags.SUBSCRIPTION_NAME) {
    if (!isEmpty(filterValues.subscriptionName)) {
      filters.push({
        model: 'SUBSCRIPTION',
        field: 'subscription_name',
        op: 'SUBSTRING',
        value: filterValues.subscriptionName
      });
    }
  }

  if (!isEmpty(filterValues.accountId)) {
    filters.push({
      model: 'SUBSCRIPTION',
      field: 'account_id',
      op: 'SUBSTRING',
      value: `${filterValues.accountId}`
    });
  }

  if (!isEmpty(filterValues.currentBalances)) {
    filters.push({
      model: 'SUBSCRIPTION',
      field: 'current_balances',
      op: 'SUBSTRING',
      value: `${filterValues.currentBalances}`
    });
  }

  if (!isEmpty(filterValues.subscriptionStatus)) {
    filters.push({
      model: 'SUBSCRIPTION',
      field: 'subscription_status',
      op: 'SUBSTRING',
      value: `${filterValues.subscriptionStatus}`
    });
  }

  const date = moment(filterValues.date);
  date
    .tz('UTC')
    .set('hour', 23)
    .set('minute', 59)
    .set('second', 59);

  return { filters, date };
}

export default {
  initialFilters: {
    payorId: '',
    subscriptionName: '',
    payorBillingName: '',
    accountId: '',
    currentBalances: true,
    subscriptionStatus: false,
    date: null,
    contactInfo: false,
  },
  reportQuery: (facilityId, filterValues, format) => {
    const data = {
      params: {
        facilityId: facilityId,
      },
      format: format,
      report: "OutstandingBalanceSummaryReport"
    }

    if (filterValues.date) {
      data.params.asOfDate = moment(filterValues.date).format('YYYY-MM-DD')
    } else {
      data.params.asOfDate = moment().format('YYYY-MM-DD')
    }

    if (filterValues.subscriptionName) {
      data.params.subscriptionName = filterValues.subscriptionName
    }

    if (filterValues.accountId) {
      data.params.accountId = filterValues.accountId
    }

    if (filterValues.payorId) {
      data.params.subscriberId = filterValues.payorId
    }

    data.params.contactInfo = filterValues.contactInfo

    data.params.currentBalances = filterValues.currentBalances

    data.params.subscriptionStatus = filterValues.subscriptionStatus

    return queryGetReport(data);
  },
  fileName: 'outstanding_balances_summary_report.csv',
  pdfFileName: 'outstanding_balances_summary_report.pdf'
}